export default {
  buttons: {
    confirm: '确定'
  },
  menus: {
    Dashboard: '仪表盘',
    ordersManagement: '订单管理'
  }
}
